import React, { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { ColorDot } from '@/design-system'
import { getWizardColors } from '../../catalog'
import { StepHint, StepLead } from '../StepCopy'

export interface ColorPickerProps {
  value?: string
  onChange: (id: string, hex: string) => void
}

export function ColorPickerStep({ value, onChange }: ColorPickerProps) {
  const colors = useMemo(() => getWizardColors(), [])
  const selected = colors.find((c) => c.id === value)

  return (
    <Box>
      <StepLead>Wall and accent color for the room.</StepLead>

      <Box display='flex' flexWrap='wrap' gap={3} alignItems='flex-start'>
        {colors.map((c) => (
          <Box
            key={c.id}
            display='flex'
            flexDirection='column'
            alignItems='center'
            gap={1.25}
            sx={{ width: 56 }}
          >
            <ColorDot
              color={c.hex}
              size={40}
              selected={value === c.id}
              label={c.name}
              onClick={() => onChange(c.id, c.hex)}
            />
            <Typography
              sx={{
                fontSize: 11,
                fontWeight: value === c.id ? 600 : 500,
                color: value === c.id ? 'var(--ds-ink)' : 'var(--ds-ink-subtle)',
                textAlign: 'center',
                lineHeight: 1.2,
                letterSpacing: '-0.01em',
              }}
            >
              {c.name}
            </Typography>
          </Box>
        ))}
      </Box>

      {selected && (
        <Box
          mt={4}
          display='flex'
          alignItems='center'
          gap={2}
          p={2}
          borderRadius={16}
          border='1px solid var(--ds-border)'
          bgcolor='var(--ds-hover)'
          maxWidth={320}
        >
          <Box
            width={48}
            height={48}
            borderRadius={12}
            bgcolor={selected.hex}
            border='1px solid rgba(17,17,17,0.08)'
            flexShrink={0}
          />
          <Box minWidth={0}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, letterSpacing: '-0.01em' }}>
              {selected.name}
            </Typography>
            <Typography sx={{ fontSize: 12, color: 'var(--ds-ink-muted)', fontFamily: 'ui-monospace, monospace' }}>
              {selected.hex}
            </Typography>
          </Box>
        </Box>
      )}

      {selected && <StepHint>{selected.name} selected — continue to materials.</StepHint>}
    </Box>
  )
}
